import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EventConvention } from 'app/models/event-convention.model';
import { DailyRegisterExtension } from 'app/models/extensions/daily-register-extension.model';
import { LOVProcessedStatus } from 'app/models/lov-processed-status.model';
import { Note } from 'app/models/note.model';
import { ProcessedEntity } from 'app/models/processed-entity.model';
import { MRMValidators } from '@mrm/core';

export class DailyRegister extends DailyRegisterExtension {
  dailyRegisterDBID: number = 0;
  dailyRegisterDT?: Date = null;
  processedEntityDBID: number = 0;
  conventionDBID: number = 0;
  hasQualifyToReceive?: boolean = null;
  isQualifyToReceiveOverride?: boolean = null;
  qualifyToReceiveOverrideDT?: Date = null;
  qualifyToReceiveOverrideNoteDBID?: number = null;
  notQualifyReasonDBID?: number = null;
  notQualifyReasonLetterProcessedDT?: Date = null;
  notQualifyReasonProcessedStatusDBID?: number = null;
  hasQualifyToSit?: boolean = null;
  isQualifyToSitOverride?: boolean = null;
  qualifyToSitOverrideDT?: Date = null;
  qualifyToSitOverrideNoteDBID?: number = null;
  credentialTotal?: number = null;
  credentialSystemGenerated?: number = null;
  credentialUserAdded?: number = null;
  credentialCancelled?: number = null;
  credentialSystemCalculated?: number = null;
  credentialAdded?: number = null;
  credentialProcessed?: number = null;
  pctAmount?: number = null;
  defenseFundLevy?: number = null;
  solidarityLevy?: number = null;
  unapplied?: number = null;
  dr?: boolean = null;
  pctInterest?: number = null;
  defenseFundInterest?: number = null;
  solidarityInterest?: number = null;
  totalShort?: number = null;
  lastMonthPaidDT?: Date = null;
  omittedMonths?: number = null;
  membershipAverage?: number = null;
  membershipFullTime?: number = null;
  membershipPartTime?: number = null;
  pctCommentNoteDBID?: number = null;
  pctHiddenCommentNoteDBID?: number = null;
  localCommentNoteDBID?: number = null;
  pctNumberOfUnits?: number = null;
  charterDate?: Date = null;
  luisStatusCode: string = null;
  numberOfUnits: number = 0;
  devNoteDBID?: number = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  convention: EventConvention = null;
  devNote: Note = null;
  localCommentNote: Note = null;
  notQualifyReasonProcessedStatus: LOVProcessedStatus = null;
  pctCommentNote: Note = null;
  pctHiddenCommentNote: Note = null;
  processedEntity: ProcessedEntity = null;
  qualifyToReceiveOverrideNote: Note = null;
  qualifyToSitOverrideNote: Note = null;

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      dailyRegisterDBID: new FormControl({ value: 0, disabled: disableAll }),
      dailyRegisterDT: new FormControl({ value: null, disabled: disableAll }),
      processedEntityDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      conventionDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      hasQualifyToReceive: new FormControl({ value: null, disabled: disableAll }),
      isQualifyToReceiveOverride: new FormControl({ value: null, disabled: disableAll }),
      qualifyToReceiveOverrideDT: new FormControl({ value: null, disabled: disableAll }),
      qualifyToReceiveOverrideNoteDBID: new FormControl({ value: null, disabled: disableAll }),
      notQualifyReasonDBID: new FormControl({ value: null, disabled: disableAll }),
      notQualifyReasonLetterProcessedDT: new FormControl({ value: null, disabled: disableAll }),
      notQualifyReasonProcessedStatusDBID: new FormControl({ value: null, disabled: disableAll }),
      hasQualifyToSit: new FormControl({ value: null, disabled: disableAll }),
      isQualifyToSitOverride: new FormControl({ value: null, disabled: disableAll }),
      qualifyToSitOverrideDT: new FormControl({ value: null, disabled: disableAll }),
      qualifyToSitOverrideNoteDBID: new FormControl({ value: null, disabled: disableAll }),
      credentialTotal: new FormControl({ value: null, disabled: disableAll }),
      credentialSystemGenerated: new FormControl({ value: null, disabled: disableAll }),
      credentialUserAdded: new FormControl({ value: null, disabled: disableAll }),
      credentialCancelled: new FormControl({ value: null, disabled: disableAll }),
      credentialSystemCalculated: new FormControl({ value: null, disabled: disableAll }),
      credentialAdded: new FormControl({ value: null, disabled: disableAll }),
      credentialProcessed: new FormControl({ value: null, disabled: disableAll }),
      pctAmount: new FormControl({ value: null, disabled: disableAll }),
      defenseFundLevy: new FormControl({ value: null, disabled: disableAll }),
      solidarityLevy: new FormControl({ value: null, disabled: disableAll }),
      unapplied: new FormControl({ value: null, disabled: disableAll }),
      dr: new FormControl({ value: null, disabled: disableAll }),
      pctInterest: new FormControl({ value: null, disabled: disableAll }),
      defenseFundInterest: new FormControl({ value: null, disabled: disableAll }),
      solidarityInterest: new FormControl({ value: null, disabled: disableAll }),
      totalShort: new FormControl({ value: null, disabled: disableAll }),
      lastMonthPaidDT: new FormControl({ value: null, disabled: disableAll }),
      omittedMonths: new FormControl({ value: null, disabled: disableAll }),
      membershipAverage: new FormControl({ value: null, disabled: disableAll }),
      membershipFullTime: new FormControl({ value: null, disabled: disableAll }),
      membershipPartTime: new FormControl({ value: null, disabled: disableAll }),
      pctCommentNoteDBID: new FormControl({ value: null, disabled: disableAll }),
      pctHiddenCommentNoteDBID: new FormControl({ value: null, disabled: disableAll }),
      localCommentNoteDBID: new FormControl({ value: null, disabled: disableAll }),
      pctNumberOfUnits: new FormControl({ value: null, disabled: disableAll }),
      charterDate: new FormControl({ value: null, disabled: disableAll }),
      luisStatusCode: new FormControl({ value: null, disabled: disableAll }),
      numberOfUnits: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      devNoteDBID: new FormControl({ value: null, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),

    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'convention':
            form.addControl('convention', EventConvention.getForm(disableAll)); break;
          case 'devnote':
            form.addControl('devNote', Note.getForm(disableAll)); break;
          case 'localcommentnote':
            form.addControl('localCommentNote', Note.getForm(disableAll)); break;
          case 'notqualifyreasonprocessedstatus':
            form.addControl('notQualifyReasonProcessedStatus', LOVProcessedStatus.getForm(disableAll)); break;
          case 'pctcommentnote':
            form.addControl('pctCommentNote', Note.getForm(disableAll)); break;
          case 'pcthiddencommentnote':
            form.addControl('pctHiddenCommentNote', Note.getForm(disableAll)); break;
          case 'processedentity':
            form.addControl('processedEntity', ProcessedEntity.getForm(disableAll)); break;
          case 'qualifytoreceiveoverridenote':
            form.addControl('qualifyToReceiveOverrideNote', Note.getForm(disableAll)); break;
          case 'qualifytositoverridenote':
            form.addControl('qualifyToSitOverrideNote', Note.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of DailyRegister. Please use one of the following navigational property: 'convention' | 'devNote' | 'localCommentNote' | 'notQualifyReasonProcessedStatus' | 'pctCommentNote' | 'pctHiddenCommentNote' | 'processedEntity' | 'qualifyToReceiveOverrideNote' | 'qualifyToSitOverrideNote'`);
        }
      }
    }

    return form;
  }
}